export default {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  lunchEditing: 'Lunch Editing',
  monthlyExpenses: 'Users Expenses',
  ordersHistory: 'Orders History',
  ordersList: 'Orders List',
  ordersCounts: 'Orders Counts',
  dishesRatings: 'Dishes Ratings',
  settings: 'Settings',
  signOut: 'Sign Out',
  noSelections: 'No Selections',
  lunchArrivedNotification: 'Send a notification, that lunch has Arrived',
  dishRatingsNotification: 'Send a notification, to remind about rating dishes',
  notifications: 'Notifications',
  selectNotifications: 'Select which Push Notifications to receive',
  lunchArrived: 'Lunch Arrived to the office',
  '10minutesReminder': '10 Minutes reminder.',
  fridayLunchAdded: 'Lunch was added',
  orderRatingReminder: 'Order rating reminder',
  notifiedUsers: 'Notification was sent successfully.',
  notificationsError: 'An error has occured while sending notifications.',
  rateLunch: 'Rate your lunch',
  rateLunchOn: 'Rate your lunch on {date} {providerTitle}',
  rateLunchSubtitle: 'Select appropriate rating and optionally write a comment.',
  soup: 'Soup {dish}',
  main: 'Main Dish {dish}',
  comment: 'Comment',
  modalHeader: 'Please choose your Preferences',
  modalSubHeader: 'These can be changed at any time in settings.',
  displayName: 'First and Last name',
  notEnabled: 'Push Notifications are Disabled',
  pleaseEnable: 'You have disabled push notifications or this browser does not support them.',
  saveButton: 'Save Selections',
  commentMustNotExceed: 'Comment must not exceed {count} characters.',
  orderSaved: 'Order Saved.',
  doNotOrder: 'Do not order for today.',
  manageNotifications: 'Manage Push Notifications.',
  usersBalances: 'Users Balances',
  balanceInfo: `Ordering is available only if total balance is sufficient
  (except for Friday lunch, which is free of charge). To top up your balance contact your office administrator.`,
  balanceReminder: 'Low balance reminder',
  balanceReminderNotification: 'Send a balance top up notification to users with a low balance',
  balanceTresholdField: 'Balance threshold',
  orderAmount: 'Order amount',
  selectedDishes: 'Selected Dishes',
  errorPage: 'An error has occured. Check console messages or response of the request for more details and try again',
};
